import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StringUtils } from '@hmax-order/shared/string';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private _snack = inject(MatSnackBar);
  private _translocoService = inject(TranslocoService);

  /**
   * Exibir mensagem de sucesso
   */
  openSaveSuccess(tag?: string): void {
    const tagUse = tag ?? 'save-success';
    const message = StringUtils.capitalize(this._translocoService.translate(tagUse));
    this._snack.open(message, 'X', { duration: 3000 });
  }

  openInfo(tag?: string): void {
    const tagUse = tag ?? 'info';
    const message = StringUtils.capitalize(this._translocoService.translate(tagUse));
    this._snack.open(message, '', { duration: 3000 });
  }
}
